/**
 * Created by CCristi <ccovali@mitocgroup.com> on 12/10/15.
 */

/*eslint no-undefined: 0*/

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let Context = exports.Context = function () {
  /**
   * @param {Object} lambdaContext
   */
  function Context(lambdaContext) {
    _classCallCheck(this, Context);

    this._lambdaContext = lambdaContext;

    this._registerDataAsOptions();
  }

  /**
   * @returns {Object}
   */


  _createClass(Context, [{
    key: '_registerDataAsOptions',


    /**
     * @private
     */
    value: function _registerDataAsOptions() {
      for (let key in this._lambdaContext) {
        if (!this._lambdaContext.hasOwnProperty(key)) {
          continue;
        }

        Object.defineProperty(this, key, {
          value: this._lambdaContext[key],
          writable: false,
          configurable: false,
          enumerable: true
        });
      }

      // Avoid _data key listing on Object.keys(request)
      Object.defineProperty(this, '_options', {
        configurable: false,
        enumerable: false
      });
    }

    /**
     * @param {String} option
     * @returns {boolean}
     */

  }, {
    key: 'has',
    value: function has(option) {
      return this._lambdaContext.hasOwnProperty(option);
    }

    /**
     * @param {String} option
     * @param {*} defaultValue
     * @returns {*}
     */

  }, {
    key: 'getOption',
    value: function getOption(option) {
      let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      return this._lambdaContext.hasOwnProperty(option) ? this._lambdaContext[option] : defaultValue;
    }

    /**
     * Enables Callback wait for empty event loop
     */

  }, {
    key: 'waitForEmptyEventLoop',
    value: function waitForEmptyEventLoop() {
      this._lambdaContext.callbackWaitsForEmptyEventLoop = true;
    }
  }, {
    key: 'options',
    get: function get() {
      return this._lambdaContext;
    }
  }]);

  return Context;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-core/lib.compiled/AWS/Lambda/Context.js
// module id = 360
// module chunks = 0